import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import axios from 'axios';

const CodeEntry = ({ email, cooldownSeconds, onResend, onBack }) => {
    const [code, setCode] = useState('');
    const [verifying, setVerifying] = useState(false);
    const [error, setError] = useState('');

    const handleVerify = async (e) => {
        e.preventDefault();
        setError('');
        setVerifying(true);

        try {
            const res = await axios.post('/auth/verify-code', { email, code });
            if (res.data.success) {
                window.location.href = res.data.redirect;
            }
        } catch (err) {
            setCode('');
            if (err.response?.data?.error) {
                setError(err.response.data.error);
            } else {
                setError('Something went wrong. Please try again.');
            }
            setVerifying(false);
        }
    };

    const handleCodeChange = (e) => {
        // Only allow digits, max 6 characters
        const value = e.target.value.replace(/\D/g, '').slice(0, 6);
        setCode(value);
    };

    return (
        <>
            {/* Dark Header */}
            <div style={{
                background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
                padding: '100px 0 4rem'
            }}>
                <Container>
                    <Row className="justify-content-center">
                        <Col md={6} lg={5} className="text-center">
                            <h1 style={{
                                color: 'white',
                                fontWeight: '700',
                                fontSize: '2.25rem',
                                marginBottom: '0.75rem'
                            }}>
                                Check Your Email
                            </h1>
                            <p style={{
                                color: 'rgba(255, 255, 255, 0.7)',
                                fontSize: '1.1rem',
                                margin: 0
                            }}>
                                If <strong style={{ color: 'white' }}>{email}</strong> has access, we've sent a 6-digit code.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </div>

            {/* Code Entry Form */}
            <Container style={{ marginTop: '-2rem', paddingBottom: '3rem' }}>
                <Row className="justify-content-center">
                    <Col md={6} lg={5}>
                        <div style={{
                            background: 'white',
                            borderRadius: '16px',
                            padding: '2.5rem',
                            boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
                            textAlign: 'center'
                        }}>
                            <p style={{ color: '#64748b', fontSize: '0.9rem', margin: '0 0 1.5rem 0' }}>
                                Check your inbox and spam folder
                            </p>

                            <form onSubmit={handleVerify}>
                                <input
                                    type="text"
                                    inputMode="numeric"
                                    autoComplete="one-time-code"
                                    value={code}
                                    onChange={handleCodeChange}
                                    placeholder="000000"
                                    maxLength={6}
                                    autoFocus
                                    style={{
                                        width: '100%',
                                        height: '60px',
                                        border: '2px solid #e2e8f0',
                                        outline: 'none',
                                        borderRadius: '10px',
                                        fontSize: '2rem',
                                        fontFamily: "'Courier New', Courier, monospace",
                                        textAlign: 'center',
                                        letterSpacing: '8px',
                                        color: '#1a1a2e',
                                        marginBottom: '1rem',
                                        transition: 'border-color 0.2s'
                                    }}
                                    onFocus={(e) => { e.target.style.borderColor = '#6366f1'; }}
                                    onBlur={(e) => { e.target.style.borderColor = '#e2e8f0'; }}
                                />

                                <button
                                    type="submit"
                                    disabled={code.length !== 6 || verifying}
                                    style={{
                                        width: '100%',
                                        height: '50px',
                                        background: code.length === 6 && !verifying
                                            ? 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)'
                                            : '#e2e8f0',
                                        color: code.length === 6 && !verifying ? 'white' : '#94a3b8',
                                        border: 'none',
                                        borderRadius: '10px',
                                        fontWeight: '600',
                                        fontSize: '1rem',
                                        cursor: code.length === 6 && !verifying ? 'pointer' : 'not-allowed',
                                        transition: 'all 0.2s'
                                    }}
                                >
                                    {verifying ? 'Verifying...' : 'Verify Code'}
                                </button>
                            </form>

                            {error && (
                                <p style={{
                                    marginTop: '1rem',
                                    color: '#ef4444',
                                    fontSize: '0.9rem'
                                }}>
                                    {error}
                                </p>
                            )}

                            <div style={{ marginTop: '1.5rem' }}>
                                {cooldownSeconds > 0 ? (
                                    <p style={{ color: '#94a3b8', fontSize: '0.85rem', margin: '0 0 0.5rem 0' }}>
                                        Resend code in {cooldownSeconds}s
                                    </p>
                                ) : (
                                    <button
                                        type="button"
                                        onClick={onResend}
                                        style={{
                                            background: 'none',
                                            border: 'none',
                                            color: '#6366f1',
                                            fontSize: '0.85rem',
                                            cursor: 'pointer',
                                            textDecoration: 'underline',
                                            padding: 0,
                                            marginBottom: '0.5rem',
                                            display: 'block',
                                            margin: '0 auto 0.5rem'
                                        }}
                                    >
                                        Didn't receive a code? Resend
                                    </button>
                                )}

                                <button
                                    type="button"
                                    onClick={onBack}
                                    style={{
                                        background: 'none',
                                        border: 'none',
                                        color: '#94a3b8',
                                        fontSize: '0.85rem',
                                        cursor: 'pointer',
                                        textDecoration: 'underline',
                                        padding: 0
                                    }}
                                >
                                    Use a different email
                                </button>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default CodeEntry;
